export default __webpack_public_path__ + "static/media/Icon-open-account-logout.d359723d.svg";